import React from "react";
import { connect } from "react-redux";
import { Modal, Button, Glyphicon } from "react-bootstrap";
import { ElementStatus, DataType, Tag, Mode } from "./constant";
import uuidv4 from "uuid/v4";

class FieldModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: uuidv4(),
      field: "",
      dataTypeKey: DataType.String,
      mode: Mode.NEW,
      isSaving: false,
    };
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.mode === Mode.NEW) {
      this.setState({
        id: uuidv4(),
        field: "",
        dataTypeKey: DataType.String,
        mode: Mode.NEW,
        isSaving: false,
      });
    } else if (nextProps.mode === Mode.EDIT) {
      this.setState({
        id: nextProps.field.id,
        field: nextProps.field.field,
        dataTypeKey: nextProps.field.dataTypeKey,
        mode: Mode.EDIT,
      });
    }
  }

  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }

  async onSave() {
    this.setState({
      isSaving: true,
    });
    await this.props.onSave(this.state, this.props.mode);
    this.setState({
      isSaving: false,
    });
  }

  render() {
    const { dataTypes } = this.props;
    const { dataTypeKey, field } = this.state;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <h3> {this.state.mode === Mode.NEW ? "Add New" : "Edit"} Field</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <label>Field Name</label>
            <input
              id="field"
              type="text"
              className="form-control"
              value={field}
              onChange={this.handleChange}
            ></input>

            <label>Data Type</label>
            <select
              id="dataTypeKey"
              className="form-control"
              value={dataTypeKey}
              onChange={this.handleChange}
            >
              {dataTypes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-primary pull-right"
            disabled={this.state.isSaving}
            style={{ marginLeft: 10 }}
            onClick={() => {
              this.onSave();
            }}
          >
            Save
            {this.state.isSaving ? (
              <span>
                <i className="fa fa-spinner fa-spin" />
              </span>
            ) : (
              <span></span>
            )}
          </Button>
          <Button className="btn btn-secondary" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let dataTypes = state.configuration.elementProperties.dataTypes.filter(
    (x) => {
      if (
        x.id === DataType.String ||
        x.id === DataType.Integer ||
        x.id === DataType.Boolean ||
        x.id === DataType.Date
      ) {
        return x;
      }
    }
  );
  return {
    dataTypes: dataTypes,
  };
};
export default connect(mapStateToProps)(FieldModal);
